import { LogItemLayout } from '@features/components/ClinicalData/components/ClinicalLog/components/LogItemLayout';
import {
  BaseEvent,
  BaseEventProps,
} from '@features/components/ClinicalData/components/ClinicalLog/components/BaseEvent';

type EventVariant = {
  variant?: 'base' | 'success' | 'danger' | 'dark';
};

const cssStyles = {
  base: {
    bg: 'bg-base-70',
    text: 'text-base-10',
  },
  success: {
    bg: 'bg-green-70',
    text: 'text-base-10',
  },
  danger: {
    bg: 'bg-danger-70',
    text: 'text-base-10',
  },
  dark: {
    bg: 'bg-base-10',
    text: 'text-white',
  },
};

const headerSharedVariantMap = {
  dark: 'light',
  base: 'base',
  success: 'base',
  danger: 'base',
} as const;

export const BaseEventItem = ({
  onShareClick,
  shared,
  description,
  event,
  variant = 'base',
  ...props
}: BaseEventProps & EventVariant) => {
  const styles = cssStyles[variant];
  const headerSharedVariant = headerSharedVariantMap[variant];

  return (
    <LogItemLayout className={styles.bg}>
      <BaseEvent
        {...props}
        onShareClick={onShareClick}
        event={event}
        description={description}
        shared={shared}
        headerSharedVariant={headerSharedVariant}
        descriptionCss={styles.text}
      />
    </LogItemLayout>
  );
};
